const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

const api = {
  allUsers: () => `${apiBaseUrl}/api/v1/users/`,
  user: (id: string) => `${apiBaseUrl}/api/v1/users/${id}/`,
  userProfile: () => `${apiBaseUrl}/api/v1/users/me/`,
  users: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/api/v1/users/?page=${page}&pageSize=${pageSize}`,
  allProjects: () => `${apiBaseUrl}/projects`,
  project: (id: string) => `${apiBaseUrl}/projects/${id}`,
  projects: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/projects/?page=${page}&pageSize=${pageSize}`,
  avatars: () => `${apiBaseUrl}/avatars`,
  health: () => `${apiBaseUrl}/api/v1/health/`,
  authLogin: () => `${apiBaseUrl}/api/v1/auth/login/`,
  authRefresh: () => `${apiBaseUrl}/api/v1/auth/refresh/`,
  authSignup: () => `${apiBaseUrl}/api/v1/auth/signup/`,
  authMe: () => `${apiBaseUrl}/api/v1/auth/me/`,
  authChangePassword: () => `${apiBaseUrl}/api/v1/auth/change-password/`,
  authForgotPassword: () => `${apiBaseUrl}/api/v1/auth/forgot-password/`,
  authResetPasswordConfirm: () => `${apiBaseUrl}/api/v1/auth/reset-password-confirm/`,
  changePassword: () => `${apiBaseUrl}/api/v1/users/change-password/`,
  userResetPassword: (id: string) => `${apiBaseUrl}/api/v1/users/${id}/reset_password/`,
  categories: () => `${apiBaseUrl}/api/v1/categories/`,
  category: (id: string) => `${apiBaseUrl}/api/v1/categories/${id}/`,
  transactions: () => `${apiBaseUrl}/api/v1/transactions/`,
  transaction: (id: string) => `${apiBaseUrl}/api/v1/transactions/${id}/`,
  transactionsProcessRecurring: () => `${apiBaseUrl}/api/v1/transactions/process_recurring/`,
  budgets: () => `${apiBaseUrl}/api/v1/budgets/`,
  budget: (id: string) => `${apiBaseUrl}/api/v1/budgets/${id}/`,
  notifications: () => `${apiBaseUrl}/api/v1/notifications/`,
  notification: (id: string) => `${apiBaseUrl}/api/v1/notifications/${id}/`,
  notificationsPushToken: () => `${apiBaseUrl}/api/v1/notifications/push-token/`,
  reportsSummary: () => `${apiBaseUrl}/api/v1/reports/`,
  reportsMonthly: () => `${apiBaseUrl}/api/v1/reports/monthly/`,
  reportsByCategory: () => `${apiBaseUrl}/api/v1/reports/by_category/`,
  reportsBudgetsStatus: () => `${apiBaseUrl}/api/v1/reports/budgets_status/`,
  reportsDaily: () => `${apiBaseUrl}/api/v1/reports/daily/`,
  reportsWeekly: () => `${apiBaseUrl}/api/v1/reports/weekly/`,
  reportsExport: () => `${apiBaseUrl}/api/v1/reports/export/`,
  sync: () => `${apiBaseUrl}/api/v1/sync/`,
}

export default api
